package com.example.readingnotes.presentation.theme

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

class ThemeViewModel {
    private val _state = MutableStateFlow(ThemeState())
    val state: StateFlow<ThemeState> = _state.asStateFlow()

    fun updateThemeMode(themeMode: ThemeMode) {
        _state.update {
            val isDarkMode =
                when (themeMode) {
                    ThemeMode.LIGHT -> false
                    ThemeMode.DARK -> true
                    ThemeMode.SYSTEM -> {
                        // In a real app, this would check system preferences
                        // For now, default to light
                        false
                    }
                }
            it.copy(
                themeMode = themeMode,
                isDarkMode = isDarkMode,
            )
        }
    }

    fun toggleTheme() {
        val currentMode = _state.value.themeMode
        val newMode =
            when (currentMode) {
                ThemeMode.LIGHT -> ThemeMode.DARK
                ThemeMode.DARK -> ThemeMode.LIGHT
                ThemeMode.SYSTEM -> ThemeMode.DARK
            }
        updateThemeMode(newMode)
    }
}
